<template>

    <m-edit1/>

    <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-11 mx-auto mt-2 text-center" >
                <template #default>(ارسال بصورت پس کرایه می باشد)   </template>
                </m-Alert-1><m-div v-bind='{...{},...{}}' :style='""' class="container bg-light p-2 rounded text-center" >
                <template #default>   <m-h3 v-bind='{...{},...{}}' :style='""' class="h5" >
                <template #default>شماره کارت جهت واریز به نام: علی بارگاهی   </template>
                </m-h3><m-p v-bind='{...{},...{}}' :style='""' class="mt-3 font-weight-bolder" >
                <template #default>بانک ملی ایران   </template>
                </m-p><m-copy-1 v-bind='{...{"itemId":6037991225470693,"itemType":"text","iconName":"files"},...{}}' :style='""' class="" >
                <template #default> 6037-9912-2547-0693   </template>
                </m-copy-1><m-p v-bind='{...{},...{}}' :style='""' class="mt-3 font-weight-bolder" >
                <template #default>شماره شبا   </template>
                </m-p><m-copy-1 v-bind='{...{"itemId":"IR86 0170 0000 0011 9715 4990 09","itemType":"text","iconName":"files"},...{}}' :style='""' class="" >
                <template #default>IR86 0170 0000 0011 9715 4990 09
   </template>
                </m-copy-1></template>
                </m-div><m-verify-transaction-1 v-bind='{...{},...{}}' :style='""' class="my-5 container" ></m-verify-transaction-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mCopy1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Copy/Copy1'; import mVerifyTransaction1 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/VerifyTransaction/VerifyTransaction1';

export default {
    name: 'HomeView',
    components: {mEdit1, mAlert1,mDiv,mH3,mP,mCopy1,mVerifyTransaction1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
